export enum PromoRetainedPhase {
  planned = 'prevu',
  reel = 'reel',
  commanded = 'commande'
}
